import React from 'react';

const ErrorAlert = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Ikon Error"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7597 8.93007C15.7597 8.95261 15.7593 8.97506 15.7585 8.99741C15.7593 9.01831 15.7597 9.03946 15.7597 9.06085C15.7597 9.21102 15.7369 9.42063 15.6914 9.68969L14.2186 16.9748C14.1813 17.1594 14.019 17.2921 13.8307 17.2921C13.6417 17.2921 13.4791 17.1585 13.4424 16.9731L12.0027 9.68969C11.9603 9.48367 11.931 9.31025 11.9149 9.16943C11.9051 9.08358 11.9002 9.00984 11.9002 8.94822L11.9003 8.94023L11.9002 8.93007C11.9002 7.86432 12.7642 7.00037 13.83 7.00037C14.8957 7.00037 15.7597 7.86432 15.7597 8.93007ZM14.7398 20.7008C14.4886 20.953 14.1854 21.0792 13.83 21.0792C13.4745 21.0792 13.1713 20.953 12.9202 20.7008C12.669 20.4485 12.5435 20.1439 12.5435 19.7869C12.5435 19.4376 12.669 19.1368 12.9202 18.8846C13.1713 18.6323 13.4745 18.5062 13.83 18.5062C14.1854 18.5062 14.4886 18.6323 14.7398 18.8846C14.9909 19.1368 15.1164 19.4376 15.1164 19.7869C15.1164 20.1439 14.9909 20.4485 14.7398 20.7008Z"
          fill="#DB0F00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5023 12.9504C27.8774 13.6001 27.8774 14.4006 27.5023 15.0504L21.6606 25.1685C21.2855 25.8182 20.5922 26.2185 19.8419 26.2185H8.15851C7.40825 26.2185 6.71498 25.8182 6.33985 25.1685L0.498144 15.0504C0.123014 14.4006 0.123014 13.6001 0.498144 12.9504L6.33985 2.83223C6.71498 2.18248 7.40825 1.78223 8.15851 1.78223L19.8419 1.78223C20.5922 1.78223 21.2855 2.18248 21.6606 2.83223L27.5023 12.9504ZM26.2899 14.3504C26.4149 14.1338 26.4149 13.8669 26.2899 13.6504L20.4481 3.53223C20.3231 3.31565 20.092 3.18223 19.8419 3.18223L8.15851 3.18223C7.90842 3.18223 7.67733 3.31565 7.55229 3.53223L1.71058 13.6504C1.58554 13.8669 1.58554 14.1338 1.71058 14.3504L7.55229 24.4685C7.67733 24.6851 7.90842 24.8185 8.15851 24.8185H19.8419C20.092 24.8185 20.3231 24.6851 20.4481 24.4685L26.2899 14.3504Z"
          fill="#DB0F00"
        />
        <defs></defs>
      </svg>
    </>
  );
};
export default ErrorAlert;
